import { formatAmount as utilFormatAmount } from '@ecster/util';

/**
 * Format an amount with
 * @param amount
 * @param options
 *    currency: undefined | SEK | EUR | etc (options.style='currency' is added automatically if set)
 *    decimals: 0 | 1 | 2 | etc
 *    strip00: true (default) | false
 *    round: true | false (default)
 *    roundUp: true | false (default)
 *    roundDown: true | false (default)
 *    positive: true | false (default)
 *    hasCurrency true (default) | false - show currency or not
 * @returns {*|string}
 */

type FormatAmount = (
    amount: number,
    options?: {
        currency?: string;
        decimals?: number;
        strip00?: boolean;
        round?: boolean;
        roundUp?: boolean;
        roundDown?: boolean;
        positive?: boolean;
        isOnlyPositive?: boolean;
        currencyDisplay?: string;
        hasCurrency?: boolean;
    }
) => string;

export const formatAmount: FormatAmount = (amount, options = { strip00: true, hasCurrency: true }) => {
    const theOptions = { ...options };
    theOptions.positive = options.isOnlyPositive;

    return utilFormatAmount(amount, 'sv-SE', options.currency || 'SEK', theOptions);
};
